import React from "react";
import { ErrorMessage, Stack, ValidationResult } from "sprint-common-web";

import { AccessKey } from "../useGenerateAccessKeyPage";
import { AccessKeyInfo } from "./AccessKeyInfo";
import { GenerateAccessKeyStack } from "./GenerateAccessKeyStack";

interface GenerateAccessKeyStackContent {
    isLoading: boolean;
    bucketName: string;
    isAccessKeyGenerating: boolean;
    validationResult: ValidationResult | undefined;
    accessKeyInfo: AccessKey | undefined;
    onClick(): void;
}

export const GenerateAccessKeyContent: React.VFC<GenerateAccessKeyStackContent> = ({
    isLoading,
    bucketName,
    isAccessKeyGenerating,
    validationResult,
    accessKeyInfo,
    onClick
}: GenerateAccessKeyStackContent) => {
    if (validationResult) {
        return (
            <Stack horizontalAlign="center">
                <ErrorMessage text="There was an error processing your request. Please note that provided link may be no longer active. Please contact Hub Staff. " />
            </Stack>
        );
    }

    if (accessKeyInfo) {
        return <AccessKeyInfo bucketName={bucketName} accessKeyInfo={accessKeyInfo} />;
    }

    return (
        <GenerateAccessKeyStack
            bucketName={bucketName}
            isAccessKeyGenerating={isAccessKeyGenerating}
            onClick={onClick}
            isLoading={isLoading}
        />
    );
};
